module.exports = __webpack_public_path__ + "static/media/program.85b947fb.jpeg";